<script setup>
import { ref, onMounted, watch } from 'vue';
import Header from '@/components/Header.vue';
import Icon from '@/components/Icon.vue';
import AddFeedback from './Add.vue';
import DetailFeedback from './Show.vue';
import api from '@/libs/api.js';
import {useConfigStore} from '@/stores/useConfigStore.js';
import { useRouter } from 'vue-router';

const showAddFeedback = ref(false);
const showDetail = ref(false);
const data = ref([]);
const dataShow = ref({});
const useConfig = useConfigStore();
const router = useRouter();

const getData = async () => {
    if (useConfig.contract?.id) { // Đảm bảo `contract` và `id` tồn tại
        await api.get('app/feedback/' + useConfig.contract.id)
            .then((res) => {
                data.value = res.data.data;
            })
            .catch((err) => {
                console.error('Error fetching data:', err);
            });
    }
};

// Theo dõi sự thay đổi của contract
watch(
    () => useConfig.contract,
    (newContract) => {
        if (newContract?.id) {
            getData();
        }
    },
    { immediate: true } // Chạy ngay khi component được mount nếu `contract` đã có giá trị
);
const add = () => {
    if (useConfig.contract) {
        showAddFeedback.value = true;
    }
};

const handleCallBack = () => {
    showAddFeedback.value = false;
    showDetail.value = false;
};

const detail = (val) => {
    router.push({name: 'feedback-show', params: { id: val } });
};
</script>

<template>
    <div class="w-full h-full overflow-auto">
        <Header text="phản ánh" :back="false">
            <div v-if="useConfig.contract" @click="add" class="w-full flex justify-end items-center">
                <Icon name="plus" class="w-5 h-5 fill-white" />
            </div>
        </Header>
        <div class="w-full h-full pt-14 mb-20">
            <div v-for="(item, index) in data" :key="index" class="px-6 mt-4">
                <div @click="detail(item.id)"
                    class="w-full h-auto rounded-lg shadow border border-gray-300 p-4 overflow-hidden bg-white mb-4">
                    <div class="w-full flex justify-between items-center pb-1">
                        <div class="w-max rounded px-3 py-[1px] text-xs font-bold"
                            :style="`color: ${item.status.color}; background-color: ${item.status.color}14;`">
                            {{ item.status ? item.status.name : '' }}
                        </div>
                        <p class="text-xs">
                            {{ item.issue_date }}
                        </p>
                    </div>
                    <p class="pb-1 font-bold">
                        {{ item.title }}
                    </p>
                    <p class="text-sm text-slate-500">
                        {{ item.description }}
                    </p>
                </div>
            </div>
            <div v-if="useConfig.contract && data.length === 0" class="py-4 px-6 h-full bg-white">
                <img src="@/assets/images/feedback.png" alt="No feedback" />
                <p class="text-center w-full font-bold text-lg">
                    Bạn đang cần trợ giúp chứ? 🥲
                </p>
                <p class="text-gray-400 text-xs text-justify py-2">
                    Nếu bạn đang gặp phải vấn đề, hãy tạo phản ánh để quản lý tòa nhà nắm thông tin và xử lý ngay cho
                    bạn nhé!
                </p>
                <div class="w-full flex justify-center items-center py-8">
                    <button @click="add" type="button"
                        class="w-full font-bold text-center py-3 bg-main text-white rounded shadow">
                        Tạo phản ánh
                    </button>
                </div>
            </div>
            <div v-else-if="useConfig.contract == null" class="py-4 px-6 h-full bg-white">
                <img src="@/assets/images/feedback.png" alt="No feedback" />
                <p class="text-center w-full font-bold text-lg">
                    Không thể tạo phản ánh? 🥲
                </p>
                <p class="text-gray-500 text-sm text-justify py-2">
                    Hiện tại bạn chưa liên kết hợp đồng hoặc tất cả hợp đồng thuê của bạn đã bị thanh lý. Hãy liên hệ
                    với quản lý tòa nhà nếu bạn vẫn còn đang thuê nhé!
                </p>
            </div>
        </div>
        <add-feedback :show="showAddFeedback" @call-back="handleCallBack" @call-api="getData"></add-feedback>
        <detail-feedback :show="showDetail" :data="dataShow" @call-back="handleCallBack"></detail-feedback>
    </div>
</template>
